<template>
    <b-form-group class="c-checkbox-wrapper" :class="extraClasses">
        <div v-if="label?.length && labelPosition === 'top'">
            <p>{{ label }}</p>
        </div>
        <b-form-checkbox
            v-model="model"
            v-b-tooltip.hover.left
            class="d-inline-block ignore-custom-control"
            :name="name"
            :switch="switchType"
            :disabled="disabled"
            :title="tooltip"
            @change="handleClick"
        >
            {{ computedCheckboxLabel }}
        </b-form-checkbox>
        <div v-if="label?.length && labelPosition === 'bottom'">
            <p>{{ label }}</p>
        </div>
        <b-form-text v-if="!!$slots.default">
            <slot />
        </b-form-text>
    </b-form-group>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        value: boolean;
        name?: string;
        label?: string;
        labelPosition?: 'top' | 'bottom';
        checkboxLabel?: string;
        tooltip?: string;
        enableText?: string;
        disabledText?: string;
        switchType?: boolean;
        disabled?: boolean;
        hideLabel?: boolean;
        extraClasses?: string;
    }>(),
    {
        name: '',
        labelPosition: 'top',
        enableText: 'Yes',
        disabledText: 'No'
    }
);

const emit = defineEmits<{
    (event: 'input', value: boolean): void;
    (event: 'click-checkbox', payload: { event: MouseEvent; value: boolean }): void;
}>();

const computedCheckboxLabel = computed((): string | undefined => {
    if (props.switchType && !props.checkboxLabel?.length) {
        return props.value ? props.enableText : props.disabledText;
    }
    return props.hideLabel ? '' : props.checkboxLabel;
});

const model = computed({
    get: () => props.value,
    set: (value: boolean) => {
        if (value == props.value) return;
        emit('input', value);
    }
});

const handleClick = (event: MouseEvent) => {
    emit('click-checkbox', { event, value: props.value });
};
</script>
